(function () {
    'use strict';

    angular
        .module('rms.common')
        .directive('activityFieldText', activityFieldText);

    function activityFieldText(lodash) {
        return {
            restrict: 'E',
            scope: {
                element: '=',
                // model: '=ngModel',
            },
            require: 'ngModel',
            templateUrl: 'common/app/components/activities/activity-input/fields/text',
            controller: activityFieldTextCtrl,
            link: function (scope, elem, attr, ctrl) {
                // if (!scope.model) {
                //     if (lodash.has(scope.element, 'value')) {
                //         scope.model = scope.element.value;
                //     }
                // }

                scope.state = {};

                ctrl.$formatters.push(function (modelValue) {
                    // if (typeof modelValue === typeof undefined){
                    //
                    // }
                    if (!modelValue) {
                        if (lodash.has(scope.element, 'value')) {
                            modelValue = scope.element.value;
                        }
                    }
                    return modelValue;
                });

                ctrl.$render = function () {
                    scope.state.model = ctrl.$viewValue;
                };

                scope.$watch(function () {
                    return scope.state.model;
                }, function () {
                    ctrl.$setViewValue(scope.state.model);
                })


            }
        };
    }

    function activityFieldTextCtrl($scope, $timeout, $element, lodash) {
        this.$onInit = function() {
            $scope.$on('$destroy', function() {
                var editor = $scope.tinyMceInst;
                editor.removed = true;
            });
            var default_options = {
                plugins: 'noneditable',
                menubar: false,
                toolbar: false,
                preview_styles: false,
                resize: true,
                statusbar: false,
                height: "90",
                autoresize_bottom_margin: 0,
                paste_as_text: true,
                keep_styles: false,
                content_style: '.mceNonEditable { text-decoration: none; display: inline-block; background-color: #f7761f; border: 1px solid #f46709; color: white; border-radius: 10px; padding: 0.15rem 0.35rem; } p { margin: 0 }',
                noneditable_regexp: [/<u data=["']non-editable["'][-='"\w\s]*>([\s\w]*)<\/u>/g],
                paste_preprocess: function (plugin, args) {
                    var html_content = args.content;

                    var unclean_dom = $('<div />').html(html_content);
                    unclean_dom.find('*').removeAttr('class').removeAttr('id');
                    var replace_html_value = unclean_dom.html();

                    args.content = replace_html_value.replace(/(<br[\s\/]*>)/g, '');
                },
                setup: function (editor) {
                    $scope.tinyMceInst = editor;
                    editor.SODTMCESubject = true;


                    function setHeight() {
                        var em = $element.find('.mce-tinymce');
                        em.css('max-height', '50px');
                    }

                    editor.on('keydown', function (e) {
                        if (e.keyCode == 13) {
                            e.preventDefault();
                        }
                    });
                    editor.on('Init', function (e) {
                        //on init setting max-height of subject
                        setHeight();
                    });

                    editor.on('BeforeSetContent', function (e) {
                        var tempDom = $('<div />');
                        tempDom.html(e.content);
                        tempDom.find('[style]').removeAttr('style');
                        e.content = tempDom.html();
                    });

                    editor.on('blur', (function (editor) {
                        return function (e) {
                            e.preventDefault();
                            $scope.model = editor.getContent();
                        };
                    })(editor));
                },
            };

            var remote_option = $scope.element.options;
            if (lodash.isEmpty(remote_option)) {
                remote_option = {}; // in case remote_option is array or null;
            }


            $scope.tmceOptions = angular.merge(default_options, remote_option);
        }
    }
})();
